import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Sentry, sentrySetFatalScope } from 'app/utils/sentry';
import { ElevioClient } from 'utils/elevio';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { AppFallback } from './components/appFallback/appFallback';
import { AppModals } from './components/appModals/appModals';
import { AppStatus } from './components/appStatus/appStatus';
import { useAppInit } from './utils/useAppInit/useAppInit';
import { useAppNetworkChange } from './utils/useAppNetworkChange/useAppNetworkChange';
/** A component that governs the main entry point of the application. */
export const App = ({ children }) => {
    var _a, _b;
    const agent = useAppSelector((state) => state.settings.profile.profile);
    const isAppRunning = useAppSelector(({ app: { asyncStatus, error } }) => asyncStatus.app === 'fulfilled' && !error);
    useAppInit();
    useAppNetworkChange();
    return (_jsxs(Sentry.ErrorBoundary, Object.assign({ beforeCapture: sentrySetFatalScope, showDialog: true, dialogOptions: {
            user: {
                name: (_a = agent.name) !== null && _a !== void 0 ? _a : undefined,
                email: (_b = agent.email) !== null && _b !== void 0 ? _b : undefined,
            },
        }, fallback: _jsx(AppFallback, {}) }, { children: [!isAppRunning && _jsx(AppStatus, {}), isAppRunning && (_jsxs(_Fragment, { children: [_jsx(AppModals, {}), _jsx(ElevioClient, {}), children] }))] })));
};
